import { IClassroom } from "../model";

export const classroomInitial: IClassroom = {
  name: '',
  active:false,
  organizationId:0,
  gradeLevelId:0,
  schoolId:0,
  classroomCode:"",
  curriculumId:0,
    b2CClass:false,
}
